module.exports = __webpack_public_path__ + "static/media/plumber.9d0cbe20.jpg";